import React, { useState, useEffect } from 'react';
import API from '../../Utils/api';
import toast from 'react-hot-toast';
import leaf from "../../Assets/leaf.png";
import leafone from "../../Assets/leafone.png";

import { FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { FaLocationDot } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
const InquiryModal = ({ onClose }) => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    product: '',
  });

  // Fetch all categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await API.get('/category/all');
        setCategories(res.data.data || []);
      } catch (err) {
        console.error('Error fetching categories:', err);
      }
    };
    fetchCategories();
  }, []);

  // Fetch products when category changes
  useEffect(() => {
    if (!selectedCategory) {
      setProducts([]);
      setForm(prev => ({ ...prev, product: '' }));
      return;
    }
    const fetchProducts = async () => {
      setLoadingProducts(true);
      try {
        const res = await API.get(`/inquiry/products/${selectedCategory}`);
        setProducts(res.data.data || []);
        setForm(prev => ({ ...prev, product: '' }));
      } catch (err) {
        console.error('Error fetching products:', err);
      } finally {
        setLoadingProducts(false);
      }
    };
    fetchProducts();
  }, [selectedCategory]);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Validation
  if (!selectedCategory) {
    toast.error('Please select a category');
    return;
  }

  if (!form.name.trim()) {
    toast.error('Please enter your name');
    return;
  }

  if (!form.email.trim()) {
    toast.error('Please enter your email');
    return;
  }

  // ✅ Email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(form.email.trim())) {
    toast.error('Please enter a valid email address');
    return;
  }

  if (!form.phone.trim()) {
    toast.error('Please enter your phone number');
    return;
  }

  // ✅ Phone format validation (10 digits)
  const phoneRegex = /^[6-9]\d{9}$/;
  if (!phoneRegex.test(form.phone.trim())) {
    toast.error('Please enter a valid 10-digit phone number');
    return;
  }

  if (!form.message.trim()) {
    toast.error('Please enter your message');
    return;
  }

  setLoading(true);
  try {
    await API.post('/inquiry/create', {
      ...form,
      category: selectedCategory,
      product: form.product || null,
    });
    toast.success('Inquiry submitted successfully!');
    onClose();
  } catch (err) {
    toast.error(err.response?.data?.message || 'Failed to submit inquiry');
  } finally {
    setLoading(false);
  }
};

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-[#1A3617] rounded-2xl w-full max-w-4xl shadow-2xl overflow-hidden relative"
        onClick={e => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20  transition"
        >
          ✕
        </button>

        <div className="grid grid-cols-1 md:grid-cols-2">

          {/* ── LEFT SIDE — hidden on mobile ── */}
          <div className="hidden md:flex flex-col justify-between p-8 relative overflow-hidden">
            {/* Leaf decorations */}
            <img
              src={leafone}
              alt=""
              className="absolute bottom-0 right-2 w-32 opacity-60 pointer-events-none"
            />
            <img
              src={leaf}
              alt=""
              className="absolute bottom-24 right-0 w-40 opacity-40 pointer-events-none"
            />

            {/* Heading */}
            <div className="relative z-10">
              <h2 className="text-3xl xl:text-4xl font-bold font-serif text-white leading-relaxed tracking-wide">
                Let's Enquire
                About Our{' '}
                <span className="text-[#92AD36]">Fertilizer</span>
                Solutions
              </h2>
            </div>

            {/* Contact Info */}
            <div className="relative z-10 space-y-4 mt-4">
              <div className="flex items-center gap-3 text-white/80 text-lg">
                <div className="w-8 h-8  flex items-center justify-center flex-shrink-0">
                  <FaPhoneAlt size={14} />
                </div>
                +91 99878 76567
              </div>
              <div className="flex items-center gap-3 text-white/80 text-sm">
                <div className="w-8 h-8  flex items-center justify-center flex-shrink-0">
                  <IoMail size={14} />
                </div>
                kalingabio70@gmail.com
              </div>
              <div className="flex items-start gap-3 text-white/80 text-sm">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <FaLocationDot size={14} />
                </div>
                Plot No.- 1121/4 Jagamohan Nagar,<br />
                Khandagiri, Bhubaneswar
              </div>
            </div>

            {/* Social Icons */}
            <div className="relative z-10 flex items-center gap-4 mt-8">
              {[
                { icon: <FaInstagram size={16} />, href: '#' },
                { icon: <FaFacebookF size={16} />, href: '#' },
                { icon: <FaYoutube size={16} />, href: '#' },
                { icon: <FaXTwitter size={16} />, href: '#' },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="w-8 h-8 rounded-full border border-white/30 flex items-center justify-center text-white/70 hover:text-white hover:border-white transition"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── RIGHT SIDE — Form ── */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 m-2 md:m-3">
            <p className="text-xs font-bold text-[#92AD36] tracking-widest uppercase mb-4">
              Category of Products
            </p>

            {/* Category Pills */}
            <div className="flex flex-wrap gap-2 mb-5">
              {categories.map(cat => (
                <button
                  key={cat._id}
                  type="button"
                  onClick={() => setSelectedCategory(
                    selectedCategory === cat._id ? '' : cat._id
                  )}
                  className={`px-3 py-1.5 rounded-full text-xs font-medium border transition ${
                    selectedCategory === cat._id
                      ? 'bg-[#3A7138] text-white border-[#3A7138]'
                      : 'bg-white text-gray-700 border-gray-300 hover:border-[#3A7138]'
                  }`}
                >
                  {cat.category}
                </button>
              ))}
            </div>

            <form onSubmit={handleSubmit} className="space-y-3">
              {/* Product Dropdown */}
              <div className="relative">
                <select
                  name="product"
                  value={form.product}
                  onChange={handleChange}
                  disabled={!selectedCategory || loadingProducts}
                  className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#3A7138] bg-white appearance-none disabled:opacity-50"
                >
                  <option value="">
                    {loadingProducts
                      ? 'Loading products...'
                      : !selectedCategory
                      ? 'Select a category first'
                      : products.length === 0
                      ? 'No products in this category'
                      : 'Select Product'
                    }
                  </option>
                  {products.map(p => (
                    <option key={p._id} value={p._id}>{p.name}</option>
                  ))}
                </select>
                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                  ▾
                </span>
              </div>

              {/* Name */}
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter your name here"
                required
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3A7138]"
              />

              {/* Email */}
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter Email ID"
                required
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3A7138]"
              />

              {/* Phone */}
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Enter Phone Number"
                required
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3A7138]"
              />

              {/* Message */}
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Message"
                required
                rows={3}
                className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3A7138] resize-none"
              />

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-[#3A7138] hover:bg-[#2d5a2b] text-white font-semibold rounded-lg transition disabled:opacity-60 text-sm"
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryModal;